<template lang="html">

  <section class="politica-de-privacidad">
     <section class="aviso-legal">
    <div class="container">
     <h1>POLÍTICA DE PRIVACIDAD</h1>
  
<p><strong>TRATAMIENTO DE DATOS DE CARÁCTER PERSONAL</strong></p>
<p>En cumplimiento con lo dispuesto en la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter
Personal, te informamos de que los datos personales e información que nos facilites al cumplimentar cualquier formulario
electrónico disponible en la página web de MY WORKOUTSTUDIO, serán incorporados en un fichero de datos de carácter
personal de nuestra titularidad.
La finalidad del tratamiento de tu información es dar curso a tu solicitud y nunca serán transmitidos a terceros.
Cualquier comunicación comercial vía email, mensaje digital u “ordinario” que recibas, se hará en virtud de tu
aceptación previa y expresa de nuestra Política de Privacidad y contendrá información relacionada con la actividad y los
servicios ofrecidos por MY WORKOUTSTUDI. No queremos ser spam.</p>
<p><strong>MEDIDAS DE SEGURIDAD</strong></p>
<p>Adoptamos todas las medidas de seguridad que están disponibles en el estado de la tecnología y que nos exige el
Reglamento de desarrollo de la Ley de Protección de Datos de Carácter Personal, y ponemos todos los medios que están a
nuestro alcance para evitar accesos o tratamientos fraudulentos a los datos por parte de terceros, así como su
alteración o pérdida.</p>
<p><strong>POLÍTICA DE COOKIES
</strong></p>
<p>Por favor consulta nuestra <router-link to="/politica-de-cookies">Política de Cookies</router-link>.
</p>
<p><strong>DERECHOS ARCO</strong></p>
<p>Puedes ejercer tus derechos de Acceso, Rectificación, Cancelación y Oposición (ARCO) enviándonos un email a
<a href="mailto:jlcortinap@gmail.com">jlcortinap@gmail.com</a>
</p>
<p><strong>MODIFICACIÓN</strong></p>
<p>Nos reservamos la posibilidad de modificar esta política de privacidad para adaptarla a nuevas necesidades, obligaciones
legales o criterios de la Agencia Española de Protección de Datos. Toda modificación será debidamente comunicada en la
página web de MY WORKOUTSTUDIO , en esta sección de Política de Privacidad.</p>
. 


  
   </div>
  </section>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'politica-de-privacidad',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.politica-de-privacidad {
  background: url("../../../static/img/bg-politicas.svg");
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 100px 0 100px;
  text-align: left;
  h1 {
    margin-bottom: 50px;
    line-height: 55px;
    @media screen and (max-width: 600px) {
      font-size: 25px;
      line-height: 26px;
      text-align: right;
      max-width: 100%;
    }
  }
  a {
    text-decoration: underline;
  }
  p {
    margin: 15px 0;
  }
  .container {
    @media screen and(max-width:1470px) {
      width: 100%;
      padding: 0 8vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue